
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiResistor1Off as ObiResistor1OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-resistor-1-off.js';
 
 
 

 
 export const ObiResistor1Off = createComponent({
   react: React,
   tagName: 'obi-resistor-1-off',
   elementClass: ObiResistor1OffElement,
   events: {
     
   }
  });
 
 